import React, { useState, useEffect } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    TextField,
    InputAdornment,
    IconButton,
    Menu,
    Typography,
    Button,
    Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Topbar from "../../admin/layouts/Topbar";
import Addproduct from "../../admin/components/Add_product";
import CircularProgress from "@mui/material/CircularProgress";
import instance from "../../utils/Api";
import Statusproduct from "../../admin/components/Status_product";
import { useGlobalContext } from "../../Contex"; // Adjust the path
import edit from '../../superadmin/assets/icons/add-icon.svg';
import { useNavigate, useSearchParams } from "react-router-dom";
import AddSection from "../components/Add_section";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { useSearchParams } from "react-router";

const Class = () => {
    const { openDialog, setOpenDialog } = useGlobalContext();
    const { openStatusDialog, setOpenStatusDialog } = useGlobalContext(); //status popup
    const { loading, setLoading } = useGlobalContext(); // State to handle loading
    const { anchorEl, setAnchorEl } = useGlobalContext(); //filter
    const { searchTerm, setSearchTerm } = useGlobalContext(); //search state
    const open = Boolean(anchorEl);
    const [page, setPage] = useState(0);
    const rowsPerPage = 15; // Fixed rows per page
    const startIndex = page * rowsPerPage; // Calculate the start and end index for pagination
    const [products, setProducts] = useState([]);
    const [addproducts, setAddproducts] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const classesId = searchParams.get('classId');
    const classesnanme = searchParams.get('classname');

    // Handle search
    const filteredProducts = products.filter((product) => {
        const searchTermLower = searchTerm.toLowerCase(); // Ensure searchTerm is always a string
        return (
            product?.name?.toLowerCase().includes(searchTermLower)
            //   product?.unit?.toLowerCase().includes(searchTermLower)
            // product?.status?.toLowerCase().includes(searchTermLower)
            // product?.age_limit?.toString().includes(searchTermLower)||
        );
    });

    //handle change
    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Adjust to be 1-based
    };

    // Data slicing based on current page and rowsPerPage
    const paginatedproducts = filteredProducts.slice(
        page * rowsPerPage,
        (page + 1) * rowsPerPage
    );

    //filter function open menu
    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
    };

    //filter function close menu
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    //fetch products
    const fetchProducts = async () => {
        try {
            let response;
            if (classesId) {
                response = await instance.get(`/api/v1/newrouts/getClassbyId?id=${classesId}`);
                setProducts(response.data.data.sections);
            } else {
                response = await instance.get("/api/v1/newrouts/getClasses");
                setProducts(response.data.data);
            }
            // setProducts(response.data.data);
        } catch (error) {
            console.error("Error fetching Products:", error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
        setAddproducts(false); // Reset after fetching
        setLoading(true);
        setPage(0);
    }, [addproducts, classesId]);

    // Function to handle opening the popup for adding new admin
    const handleAddClick = () => {
        setSelectedProduct(null); // Clear selected admin (add new mode)
        setOpenDialog(true); // Open the popup
    };
    const handleAddsectionClick = () => {
        setSelectedProduct(null); // Clear selected admin (add new mode)
        setOpenStatusDialog(true); // Open the popup
    };

    const handleEditClick = (product) => {
        setSelectedProduct(product);
        setOpenDialog(true);
    }
    const handleEditsectionClick = (product) => {
        setSelectedProduct(product);
        setOpenStatusDialog(true);
    }

    // Function to handle status click and open the popup
    const handleStatusClick = (product) => {
        setSelectedProduct(product); // Store the selected product
        setOpenStatusDialog(true); // Open the popup
    };

    return (
        <React.Fragment>
            <Topbar />
            {loading ? (
                <div className="loading">
                    <CircularProgress />
                </div>
            ) : (
                <section className="main">
                    <div className="employees-text">
                        <Typography variant="h5">{classesId ? `Section (${classesnanme})` : 'Class'}</Typography>
                        <div className="back_buttons">
                            {classesId &&
                                <Button variant="outlined" onClick={() => navigate(-1)}>
                                    <ArrowBackIcon /> Back
                                </Button>}
                            <Button variant="outlined" onClick={classesId ? handleAddsectionClick : handleAddClick}>
                                {classesId ? 'Add Section' : 'Add Class'}
                            </Button>
                        </div>
                    </div>
                    <div className="employees-main">
                        <div className="employees-content ">
                            <div className="search-options">
                                <TextField
                                    placeholder="Search"
                                    type="search"
                                    variant="outlined"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(0);
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <div className="pagination-options table-pagination">
                                <div className="pagination-animation"></div>
                                <TablePagination
                                    component="div"
                                    count={filteredProducts?.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page} // Adjust to be 0-based for MUI TablePagination
                                    onPageChange={handleChangePage}
                                    rowsPerPageOptions={[]}
                                    labelDisplayedRows={({ from, to, count }) =>
                                        `${from} to ${to} of ${count !== -1 ? count : `more than ${to}`
                                        }`
                                    }
                                />
                            </div>
                        </div>
                        <div className="employee-table">
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <div className="employee-name">S.NO</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">{classesId ? 'Section Name' : 'Class Name'}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">{classesId ? 'Students' : 'Sections'}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="employee-name">Action</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedproducts.length > 0 ? (
                                            paginatedproducts.map((product, index) => (
                                                <TableRow abIndex={-1} key={product._id}>
                                                    <TableCell component="th" scope="row">
                                                        {startIndex + index + 1}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {product?.name}
                                                    </TableCell>
                                                    <TableCell align="left" >{classesId ? product?.students?.length : product?.sections?.length} <span style={{ cursor: 'pointer', color: 'blue' }} onClick={() => classesId ? navigate(`/admin/Students?classId=${classesId}&sectionId=${product?._id}&classname=${classesnanme}`) : navigate(`/admin/classes?classId=${product?._id}&classname=${product?.name}`)}>view</span></TableCell>
                                                    <TableCell align="left">
                                                        <span
                                                            className="view"
                                                            onClick={() => classesId ? handleEditsectionClick(product) : handleEditClick(product)}
                                                        >
                                                            <Tooltip title="Update Class">
                                                                <img src={edit} alt="edit" />
                                                            </Tooltip>
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={6} align="center">
                                                    <Typography>No Data Found</Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </section>
            )
            }
            <Addproduct
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                setAddproducts={setAddproducts}
                selectedProduct={selectedProduct}
                onProductUpdate={fetchProducts}
            />
            <AddSection
                openDialog={openStatusDialog}
                setOpenDialog={setOpenStatusDialog}
                setAddproducts={setAddproducts}
                selectedProduct={selectedProduct}
                onProductUpdate={fetchProducts}
                classesId={classesId}
            />
            {/* <Statusproduct
                open={openStatusDialog}
                handleClose={() => setOpenStatusDialog(false)}
                product={selectedProduct}
                setAddproducts={setAddproducts}
            /> */}
        </React.Fragment >
    );
};

export default Class;
